import { PureComponent } from "react";
import { shouldSeeContactUs } from "services/pricing-service";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import Button from "components/core/button/button-component";
import { XS } from "/components/core/new-button/button-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { HP_SOURCE, CONTACT_US_BUTTON_CLICKED } from "constants/bigbrain-event-types";
import { getPricingContactUsLink } from "services/pricing/pricing-page/contact-us-link-service";
import { withAbTests } from "/contexts/ab-tests-context";
import { PLAN_INFO_SEGMENT_NAME } from "constants/pricing";
import { handleClientException } from "client/services/exceptions-handling-service/exceptions-handling-service";
import { shouldUseNewTypeformVariant } from "services/ab-tests/acquisition-ab-test-service";
import { pricingSignupButton, pricingContactUsButton } from "./pricing-action-button.scss";
import DefaultProps from "./default-props";
import { TYPEFORM_UNHANDLED_EXCEPTION } from "/constants/bigbrain-event-types";
import { shouldGetTypeformExperience } from "services/typeform/typeform-service";
import { openContactSalesTypeform, TYPEFORM_DESKTOP_DEVICE_TYPE } from "/constants/typeform-contact-sales";
import { shouldShowTypeformContactUs } from "/services/ab-tests/monetization-ab-tests-service";

class PricingActionButton extends PureComponent {
  constructor(props) {
    super(props);
  }

  onContactUsClicked = () => {
    const { abTests, userCount, plan, placement, isTypeformDisabled } = this.props;
    BigBrain("track", CONTACT_US_BUTTON_CLICKED, {
      placement,
      source: HP_SOURCE,
      info1: plan.tier,
      info2: userCount
    });
    const shouldShowTypeform = !isTypeformDisabled && shouldShowTypeformContactUs({ abTests });
    if (shouldShowTypeform) {
      this.displayTypeform();
    } else {
      this.redirectToSalesPage();
    }
  };

  redirectToSalesPage = () => {
    const { plan, clusterConfig, abTests, forcePricing, cookies } = this.props;
    window.location = getPricingContactUsLink(plan.tier, clusterConfig, abTests, cookies, forcePricing);
  };

  // This is bad copy-paste from use-contact-cales-typeform.js
  // Since it's deprected and will be removed soon, I didn't bother to refactor it
  // The main problem for this copy-paste is the fact that it's class component and no hooks allowed
  displayTypeform = () => {
    const {
      plan,
      clusterConfig,
      abTests,
      forcePricing,
      useNewTypeformUSVariant,
      cookies,
      forceCurrency,
      cloudfrontViewerCountry,
      isV13PricingVersion,
      testTypeformContactSales,
      forceTypeformContactSalesExperience,
      contactSalesTestMode
    } = this.props;

    const getNewVariantForTest = useNewTypeformUSVariant || shouldUseNewTypeformVariant(abTests, true);

    const pricingData = {
      forcePricing,
      cookies,
      abTests,
      forceCurrency,
      countryCode: cloudfrontViewerCountry,
      isV13PricingVersion
    };
    if (
      shouldGetTypeformExperience({
        abTests,
        cloudfrontViewerCountry,
        testTypeformContactSales,
        forceTypeformContactSalesExperience,
        sendBigBrainEvent: true
      })
    ) {
      try {
        openContactSalesTypeform({
          country: cloudfrontViewerCountry,
          deviceType: TYPEFORM_DESKTOP_DEVICE_TYPE,
          getNewVariantForTest,
          isTest: contactSalesTestMode,
          pricingData
        });
      } catch (e) {
        const bbEventParams = { name: TYPEFORM_UNHANDLED_EXCEPTION };
        handleClientException({ e, bbEventParams });
        window.location = getPricingContactUsLink(plan.tier, clusterConfig, abTests, cookies, forcePricing);
      }
    }
  };

  getContactUsButton = () => {
    const { contactUsButtonText } = this.props;
    return (
      <>
        <Button
          onClickCallback={this.onContactUsClicked}
          disableAnimation={true}
          size={XS}
          color={"outline-dark-blue-inverted-hover"}
          className="pricing-contact-us-button"
        >
          {contactUsButtonText}
        </Button>
        <style jsx>{pricingContactUsButton}</style>
      </>
    );
  };

  getRegularSignupButton = () => {
    const { plan, signupButtonText, userCount, billingPeriod } = this.props;
    return (
      <>
        <SignupFormComponent
          parentSegment={PLAN_INFO_SEGMENT_NAME}
          buttonSize={XS}
          buttonColor="outline-indigo-inverted-hover"
          ctaText={signupButtonText}
          buttonSource={plan.tier}
          useCtaText={true}
          className="pricing-signup-button"
          pricingDetails={{ tier: plan?.tier, userCount, billingPeriod }}
          extraData={{ pricing_tier: plan?.tier }}
        />
        <style jsx>{pricingSignupButton}</style>
      </>
    );
  };

  render() {
    const { plan, userCount, clusterConfig, abTests, cookies, forcePricing } = this.props;
    const { tier } = plan;
    return shouldSeeContactUs(tier, userCount, { clusterConfig, abTests, cookies, forcePricing })
      ? this.getContactUsButton()
      : this.getRegularSignupButton();
  }
}

export default withAbTests(withGenericConfig(PricingActionButton));

PricingActionButton.defaultProps = DefaultProps;
